import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';

import 'bootswatch/flatly/bootstrap.min.css';
import 'react-select/dist/react-select.min.css';

ReactDOM.render(<App />, document.getElementById('root'));


// WEBPACK FOOTER //
// ./src/index.js